import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES, CATEGORY_IMAGES } from '../../config/datamaps';

const CategoriesBar = ({ columns = 12 }) => {
    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const size = (
        windowWidth <= (767 * 12 / columns) ? 'small' :
            windowWidth < (1350 * 12 / columns) ? 'medium' : 'large'
    );

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const categoryEntries = Object.entries(CATEGORIES);

    // determine visible count based on size
    const visibleCount = size === 'small' ? 8 : (size === 'medium' ? 10 : 12);

    const visibleCategories = categoryEntries.slice(0, visibleCount);
    const hiddenCategories = categoryEntries.slice(visibleCount);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const iconSize = size === 'small' ? '30px' : (size === 'medium' ? '55px' : '80px');
    const containerPadding = size === 'small' ? 'py-1 px-2' : 'py-3 px-4';
    const itemWidth = size === 'small' ? '30px' : (size === 'medium' ? '70px' : '100px');
    const fontSize = size === 'small' ? '8px' : (size === 'medium' ? '10px' : '11px');

    return (
        <div className={`categories-bar d-flex justify-content-between align-items-start`}>
            {visibleCategories.map(([id, name]) => (
                <Link
                    key={id}
                    to={`/itemlist?category=${id}`}
                    className="category-item d-flex flex-column align-items-center text-decoration-none text-dark flex-shrink-0"
                    style={{ width: itemWidth }}
                >
                    <div
                        className={`category-icon category-${id % 5} rounded-3 p-2 d-flex align-items-center justify-content-center mb-2`}
                        style={{ width: iconSize, height: iconSize }}
                    >
                        <img
                            src={`/images/categories/${CATEGORY_IMAGES[id]}`}
                            className="img-fluid object-fit-cover"
                            alt={name}
                            onError={(e) => { e.target.style.display = 'none' }}
                        />
                    </div>
                    <span
                        className="category-title small text-center overflow-hidden w-100 px-1"
                        style={{ fontSize: fontSize, lineHeight: '1.2' }}
                    >
                        {name}
                    </span>
                </Link>
            ))}

            {hiddenCategories.length > 0 && (
                <div className="category-item position-relative" style={{ width: itemWidth }}>
                    <button
                        className="d-flex flex-column align-items-center text-dark flex-shrink-0 more-category border-0 bg-transparent p-0 w-100"
                        onClick={toggleDropdown}
                        aria-expanded={isDropdownOpen}
                        aria-haspopup="true"
                        aria-label="Show more categories"
                    >
                        <div
                            className="category-icon more-icon bg-light rounded-3 d-flex align-items-center justify-content-center mb-2 border w-100"
                            style={{ height: iconSize }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className={`bi bi-caret-down-fill text-primary transition-all ${isDropdownOpen ? 'rotate-180' : ''}`} viewBox="0 0 16 16">
                                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                            </svg>
                        </div>
                        <span className="category-title small text-center overflow-hidden w-100" style={{ fontSize: fontSize }}>More</span>
                    </button>

                    {isDropdownOpen && (
                        <div className="category-dropdown position-absolute top-100 end-0 bg-white border rounded-3 shadow p-2 z-3" style={{ width: '250px', maxHeight: '400px', overflowY: 'auto' }}>
                            {hiddenCategories.map(([id, name]) => (
                                <Link key={id} to={`/itemlist?category=${id}`} className="dropdown-item d-flex align-items-center p-2 rounded text-decoration-none text-dark hover-bg-light" onClick={() => setIsDropdownOpen(false)}>
                                    <img src={`/images/categories/${CATEGORY_IMAGES[id]}`} alt="" aria-hidden="true" className="me-3 rounded object-fit-cover" style={{ width: '32px', height: '32px' }} onError={(e) => { e.target.style.display = 'none' }} />
                                    <span className="small">{name}</span>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CategoriesBar;
